<script lang="ts">
  import Desktop from "./windows/Desktop.svelte";
  import Windows from "./Windows.svelte";
  import { FileMgr } from "./stores/FileMgr";
  import ProcMgr, { resetSaved } from "./stores/ProcMgr";
  import { onMount } from "svelte";
  import SettingsMgr, { Serializable } from "./stores/SettingsMgr";
  import { derived, get, Readable } from "svelte/store";
  import { addLog } from "./stores/LoggerStore";

  const filemgr = FileMgr.getInstance();
  const procmgr = ProcMgr.getInstance();
  const setmgr = SettingsMgr.getInstance();
  let { settingsStore } = setmgr;

  $: exceptTheme = derived(settingsStore, (settings) => {
    const copied = { ...settings };
    delete copied["theme"];
    return copied;
  });
  let autosave = setmgr.get("saveOnExit") as Readable<boolean>;
  let askonexit = setmgr.get("askOnExit") as Readable<boolean>;

  let _prevExit;
  const watchAutoSave = (save: boolean, ask: boolean) => {
    addLog(`Watch autosave : save ${save}, ask ${ask}`);
    const f = (e) => {
      if (save) {
        procmgr.add("savebread", { force: true });
      }
      if (ask) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    if (_prevExit) {
      window.removeEventListener("beforeunload", _prevExit);
    } else {
    }
    _prevExit = f;
    window.addEventListener("beforeunload", f);
  };
  $: exitWatcher = watchAutoSave($autosave, $askonexit);

  onMount(() => {
    // resetSaved(true);
    procmgr.add("loadbread", { force: true });
    watchAutoSave($autosave, $askonexit);
  });
</script>

<main class="container">
  <Desktop />
  <Windows />
</main>

<style>
  .container {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
</style>
